export interface GameRole {
  roleId: string; //角色ID
  nickname: string; //角色昵称
  hostname: string; //区服名称
}
export interface GameAccount {
  urs: string; //主账号
  platform: string; //平台
  roles: GameRole[];
}

export interface FlattedGameRole extends GameRole {
  urs: string; //主账号
  gameId: string; //游戏ID
}
export enum GameAssetName {
  L22Map = 'naraka_mobile_map',
  L22Component = 'naraka_mobile_component',
}
export enum GameAssetType {
  L22Map = 'map',
  L22Component = 'component',
}
export const GameAssetExt = {
  [GameAssetType.L22Map]: '.naraka_mobile_map',
  [GameAssetType.L22Component]: '.naraka_mobile_component',
};
export interface UgcAsset {
  id: string;
  updateTime: string;
  name: string;
  type: GameAssetType;
  thumbnail?: string;
  gameId: number; // 游戏ID
  disabled?: boolean; // 是否不可用（如已被其他任务绑定）
  disabledReason?: string; // 不可用原因
}
